import { api, getApiUrl } from 'utils/api';

const BASE_URL = getApiUrl('');

export const noticeAttachmentApi = {
  deleteAttachment: (noticeId: number, attachmentId: number): Promise<void> =>
    api(`${BASE_URL}/notices/${noticeId}/attachments/${attachmentId}`, {
      method: 'DELETE',
    }),

  downloadAttachment: (noticeId: number, attachmentId: number): Promise<Blob> =>
    api(`${BASE_URL}/notices/${noticeId}/attachments/${attachmentId}`, {
      method: 'GET',
      responseType: 'blob',
    }),
};

export const materialDownloadApi = {
  downloadAttachment: (noticeId: number, attachmentId: number): Promise<Blob> =>
    api(`${BASE_URL}/interveners/me/materials/${noticeId}/attachments/${attachmentId}`, {
      method: 'GET',
      responseType: 'blob',
    }),

  downloadAttachmentsZip: (noticeId: number): Promise<Blob> =>
    api(`${BASE_URL}/interveners/me/materials/${noticeId}/attachments/zip`, {
      method: 'GET',
      responseType: 'blob',
    }),
};
